module.exports = __webpack_public_path__ + "images/emoji/four.2d8f76f523ea7ca02cb7.png";